import { DatePicker, Typography, Dropdown } from "antd";
import type { MenuProps } from "antd";
import { Link, useLocation, useNavigate } from "react-router";
import LanguageSelect from "./language-select";
import ProfilePopover from "./profile-popover";
import { useTranslation } from "react-i18next";
import UzSymbol from "../../../assets/symbol.png";
import UzFlagSmall from "../../../assets/flag-small.png";
import { useDateRangeStore } from "@/shared/store/useDateRange";
import type { Dayjs } from "dayjs";
import CalendarIcon from "@/shared/icons/calendar";
import { twMerge } from "tailwind-merge";
import HamburgerIcon from "@/shared/icons/hamburger-icon";

const { RangePicker } = DatePicker;

function Header() {
  const monthRange = useDateRangeStore((s) => s.monthRange);
  const setMonthRange = useDateRangeStore((s) => s.setMonthRange);

  

  const location = useLocation();

  return (
    <div className="custom-container flex items-center justify-between bg-white px-4 py-3">
      <div className="flex items-center gap-9">
        <div className="flex items-center gap-[26px]">
          <Link to="/" className="flex w-max items-center gap-2">
            <img
              src={UzSymbol}
              className="block h-full w-[40px] object-contain"
            />
            <img
              src={UzFlagSmall}
              className="block h-full w-[1px] object-contain"
            />
            <Typography.Text className="sf text-primary-dark w-[285px] text-[20px] leading-[110%] font-bold uppercase">
              Ягона миллий лойиҳа бошқарув тизими
            </Typography.Text>
          </Link>
        </div>
      </div>

      <div className="flex items-center gap-3">
        {/* <RangePicker
          picker="month"
          separator="→"
          allowClear={false}
          suffixIcon={<CalendarIcon className="text-[20px]" />}
          format="MMM, YYYY"
          value={monthRange as [Dayjs, Dayjs] | null}
          onChange={(val) => setMonthRange(val as any)}
          className="month-range-picker w-[260px]"
          popupClassName="month-range-dropdown"
        /> */}
        {/* <LanguageSelect /> */}
        <ProfilePopover />
      </div>
    </div>
  );
}

export default Header;
